import React from 'react';
import moment from 'moment';

const Body = data => (
    <div>
        <p className="report_generated_date mt-2">Generated on : <ins>{moment().format('MMMM Do YYYY, h:mm:ss a')}</ins></p>
        <div className="table-responsive mt-2">
            {
                (data.shiftByDay || []).map((item, index) => {
                    return (
                        <table className="table table_center report_table" key={index}>
                            <thead>
                                <tr>
                                    <th className="annual_header" colSpan={5} key={index}>
                                        {item.date}
                                    </th>
                                </tr>
                                <tr>
                                    <th className="annual_header">Name</th>
                                    <th className="annual_header">Start</th>
                                    <th className="annual_header">End</th>
                                    <th className="annual_header">Break</th>
                                    <th className="annual_header">Total H</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{item.employeeName}</td>
                                    <td>{item.startShift}</td>
                                    <td>{item.endShift}</td>
                                    <td>{item.paidBreak}</td>
                                    <td>{item.totalHours}</td>
                                </tr>
                            </tbody>
                        </table>
                    );
                })
            }
        </div> {/* .table-responsive */}
    </div>
);
export default Body;